import { Group, Text } from "@mantine/core"
import { CommunicationStudioClasses } from "@tfg/types/constants/communication-studio.constant"
import { textColorCssVariable } from "@tfg/types/schemas/communication-studio/cssVariables"
import { FlagComponent } from "country-flag-icons/react/3x2"

import { DesignStudioParametersToolkit } from "../utils/designStudioParametersToolkit"

interface Props {
  country: string | undefined
  flag: FlagComponent | undefined
}

export const CountryLabel = ({ flag: Flag, country }: Props) => {
  return (
    <Group gap="sm">
      {Flag ? <Flag width={18} /> : null}
      <Text
        span={true}
        className={CommunicationStudioClasses.COUNTRY}
        c={DesignStudioParametersToolkit.getCssVariableLiteralName(
          textColorCssVariable
        )}
      >
        {country}
      </Text>
    </Group>
  )
}
